module.exports = __webpack_public_path__ + "static/media/home2-slider-2.7ea85ce7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home2-slider-2.jpg
// module id = 1149
// module chunks = 33